import styled from 'vue-styled-components'
const GridHover = styled.div`
pointer-events: all;
position: absolute;
width: fit-content;
padding: 2px 12px 0px;
font-family: 'Roboto';
font-size: 12px;
line-height: 12px;
left: 0px;
color: #12A9FF;
background-color: #F4FCFF;
z-index: 1;
border: 1px solid #ADDFFC;
/* border-radius: 4px 4px 0px 0px; */
&.active {
  background-color: #12A9FF;
  border: 1px solid #12A9FF;
  color: white;
}

&.disabled {
  background-color: #A9A9A9;
  border: 1px solid #A9A9A9;
  color: white;
}
&.lbl-hover:hover {
  background-color: #F4FCFF;
  border: 1px solid #12A9FF;
  color: #12A9FF;
  cursor: pointer;
}

button.dropdown-toggle {
  color: #12A9FF;
  padding: 0px 10px;
  background: transparent !important;
  border: none !important;
  &.btn-secondary:not(:disabled):not(.disabled):focus {
    &:active {
      background: transparent !important;
      border: none !important;
    }
    &:focus {
      box-shadow: none;
    }
  }
}

ul.dropdown-menu {
  background-color: transparent;
  border: none;
  li {
    background-color: #ADDFFC;
    width: fit-content;
    a {
      color: #0B77B5;
      padding: 2px 6px;
    }
    &:not(:first-child) {
      margin-top: 10px;
    }
}

`
const WrapperProps = {
  position: {}
}
const Wrapper = styled('div', WrapperProps)`
pointer-events: none;
position: absolute;
width: ${({ position }) => position.width};
height: ${({ position }) => position.height};
top: ${({ position }) => position.top};
left: ${({ position }) => position.left};
z-index: 7;
&::after {
position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  border: 1px solid #ADDFFC;
  // background-color: rgba(244,252,255, 0.3);
  z-index: 4;
}
/* border: 3px solid red; */

.lbl-name {
  bottom: 100%;
  border-bottom: 0px;
}

// &.top {
//   .lbl-name {
//     bottom: 100%;
//   }
// }
// &.bottom {
//   .lbl-name {
//     top: 100%;
//   }
// }
`

export {
  GridHover,
  Wrapper
}